module.exports = __webpack_public_path__ + "img/public/AdminIcons/backArrow.svg?f0c3c9c8";